import React, { useEffect, useState } from "react";
import styles from "./styles.m.css";
import get from "lodash/get";
import Collapsible from "react-collapsible";
import Iframe from "react-iframe";
import { PGAdwithAd } from "../../rows/ad-free";
import Media from "react-media";
import SpecialBundleCard from "../../atoms/special-bundle-card";
import LatestNewsStories from "../../atoms/latest-news-stories";
import tamilNaduCities from "../../../../server/goldpage-city.json";

const GoldDefaultPage = props => {
  const [goldRates, setGoldRates] = useState([]);
  const cityName = get(props, ["data", "cityName"]);

  // const cityNameTamil = get(props, ["data", "cityNameTamil"]);

  const [grams, setGrams] = useState(1);
  const [carat, setCarat] = useState("24");
  const [error, setError] = useState("");
  const [GoldRateResult, setGoldRateResult] = useState("");

  // Fetch gold rates and set initial values
  useEffect(() => {
    async function fetchGoldRates() {
      const response = await global.fetch("https://image.vikatan.com/gold_rate/live_update/gold_rates.json");
      const data = await response.json();
      const combinedData = processGoldRates(data);
      setGoldRates(combinedData);
    }
    fetchGoldRates();
  }, []);

  const processGoldRates = data => {
    const rateMap = new Map();

    // Process 22K rates
    data["22_c_1g"].forEach(([timestamp, price, changeText, change]) => {
      const dateKey = timestamp;
      if (!rateMap.has(dateKey)) {
        rateMap.set(dateKey, {
          timestamp,
          date: formatDate(timestamp)
        });
      }
      rateMap.get(dateKey).rate22k = {
        price: price.trim(),
        changeText,
        change: parseInt(change)
      };
    });

    // Process 24K rates
    data["24_c_1g"].forEach(([timestamp, price, changeText, change]) => {
      const dateKey = timestamp;
      if (!rateMap.has(dateKey)) {
        rateMap.set(dateKey, {
          timestamp,
          date: formatDate(timestamp)
        });
      }
      rateMap.get(dateKey).rate24k = {
        price: price.trim(),
        changeText,
        change: parseInt(change)
      };
    });

    // Convert map to array and sort by timestamp (newest first)
    return Array.from(rateMap.values()).sort((a, b) => b.timestamp - a.timestamp);
  };

  const formatDate = timestamp => {
    const date = new Date(timestamp);
    const options = {
      month: "short",
      day: "numeric",
      year: "numeric"
    };
    return date.toLocaleDateString("en-US", options);
  };
  // Update result when carat changes
  useEffect(
    () => {
      if (goldRates.length > 0) {
        const currentRate = carat === "22" ? goldRates[0].rate22k.price : goldRates[0].rate24k.price;
        setGoldRateResult(grams ? calculateTotal(grams, currentRate) : currentRate);
      }
    },
    [carat, goldRates]
  );

  const calculateTotal = (grams, rate) => {
    const numericRate = parseFloat(rate.replace(/,/g, ""));
    const total = parseFloat(grams) * numericRate;
    return total.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });
  };

  const handleCalculate = () => {
    if (!grams || parseFloat(grams) <= 0) {
      setGoldRateResult("");
      setError("Please enter valid grams");
      return;
    }

    if (goldRates.length === 0) {
      setError("Gold rates not available");
      return;
    }

    const currentRate = carat === "22" ? goldRates[0].rate22k.price : goldRates[0].rate24k.price;

    setGoldRateResult(calculateTotal(grams, currentRate));
    setError("");
  };

  const formatDateHeading = date => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const currentDate = formatDateHeading(new Date());

  const getRateRows = caratType => {
    if (goldRates.length < 2) return [];

    const todayRate = caratType === "22" ? goldRates[0].rate22k.price : goldRates[0].rate24k.price;
    const yesterdayRate = caratType === "22" ? goldRates[1].rate22k.price : goldRates[1].rate24k.price;

    const todayNumeric = parseFloat(todayRate.replace(/,/g, ""));
    const yesterdayNumeric = parseFloat(yesterdayRate.replace(/,/g, ""));

    const fixedGrams = [1, 8, 10, 100];

    return fixedGrams.map(g => {
      const todayTotal = todayNumeric * g;
      const yesterdayTotal = yesterdayNumeric * g;
      const change = todayTotal - yesterdayTotal;

      return {
        gram: g,
        yesterday: yesterdayTotal.toLocaleString("en-IN", { maximumFractionDigits: 2 }),
        today: todayTotal.toLocaleString("en-IN", { maximumFractionDigits: 2 }),
        change:
          change === 0
            ? "0" // Show "0" without +/-
            : change.toLocaleString("en-IN", {
                maximumFractionDigits: 2,
                signDisplay: "always"
              })
      };
    });
  };
  return (
    <React.Fragment>
      <div className={`${styles["goldpage-grid"]} container`}>
        <div className={styles["gold-silver-container"]}>
          <div className={`${styles["gold-page"]}`}>
            <ul className={styles["breadcrums"]}>
              <li>
                <a href="https://www.vikatan.com/">Vikatan</a>
              </li>
              <li>
                <a href="https://www.vikatan.com/collection/gold-story-page?pfrom=gold-page">News</a>
              </li>
              <li>Gold Rate Today</li>
            </ul>
            <h1 className={styles["main-title"]}>
              {`Gold Rate in - ${cityName} `}
              <span className={styles["today-date"]}>({currentDate})</span>
            </h1>
          </div>
          <div className={styles["iframe-card-container"]}>
            <Iframe
              frameBorder="0"
              className={styles["iframe-outer"]}
              src="https://special.vikatan.com/gold-page/gold_rate_graph.php"
            />
          </div>
          <div className={styles["gold-rate-widgets"]}>
            <div className={styles["gold-rate-table"]}>
              <h3>
                {`22K Gold Rate in ${cityName}`}{" "}
                <span className={styles["gold-rate-table-comparsion"]}>(Today & Yesterday)</span>
              </h3>{" "}
              <table cellPadding="10" className={styles["gold-table"]}>
                <thead>
                  <tr>
                    <th>Gram</th>
                    <th>Today</th>
                    <th>Yesterday</th>
                    <th>Change</th>
                  </tr>
                </thead>
                <tbody>
                  {getRateRows("22").map((row, index) => (
                    <tr key={index}>
                      <td>{row.gram}g</td>
                      <td>₹{row.today}</td>
                      <td>₹{row.yesterday}</td>
                      <td
                        className={
                          parseFloat(row.change) > 0
                            ? styles.positive
                            : parseFloat(row.change) < 0
                              ? styles.negative
                              : styles.neutral
                        }
                      >
                        ₹{row.change}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className={styles["gold-rate-table"]}>
              <h3>
                {`24K Gold Rate in ${cityName}`}{" "}
                <span className={styles["gold-rate-table-comparsion"]}>(Today & Yesterday)</span>
              </h3>{" "}
              <table cellPadding="10" className={styles["gold-table"]}>
                <thead>
                  <tr>
                    <th>Gram</th>
                    <th>Today</th>
                    <th>Yesterday</th>
                    <th>Change</th>
                  </tr>
                </thead>
                <tbody>
                  {getRateRows("24").map((row, index) => (
                    <tr key={index}>
                      <td>{row.gram}g</td>
                      <td>₹{row.today}</td>
                      <td>₹{row.yesterday}</td>
                      <td
                        className={
                          parseFloat(row.change) > 0
                            ? styles.positive
                            : parseFloat(row.change) < 0
                              ? styles.negative
                              : styles.neutral
                        }
                      >
                        ₹{row.change}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className={styles["calculator-wrapper"]}>
            <div className={styles["calculator-header"]}>
              <h3 className={styles["calculator-title"]}>Gold Value Calculator</h3>
              <div className={styles["calculator-carat"]}>
                <label className={`${styles["calc-radio"]} ${carat === "22" ? styles["calc-active"] : ""}`}>
                  <input type="radio" name="carat" checked={carat === "22"} onChange={() => setCarat("22")} />
                  22K
                </label>
                <label className={`${styles["calc-radio"]} ${carat === "24" ? styles["calc-active"] : ""}`}>
                  <input type="radio" name="carat" checked={carat === "24"} onChange={() => setCarat("24")} />
                  24K
                </label>
              </div>
            </div>

            <div className={styles["calc-form"]}>
              <div>
                <input
                  type="text"
                  value={grams}
                  onChange={e => {
                    const value = e.target.value.replace(/[^0-9.]/g, "");
                    if (value.length <= 5) setGrams(value);
                    // Clear result when input is being cleared
                    if (!value) {
                      setGoldRateResult("");
                      setError("");
                    }
                  }}
                  placeholder={`Gold weight (g)`}
                />
              </div>

              <button onClick={handleCalculate}>Calculate</button>

              <div className={styles["calc-result-wrapper"]}>
                <p className={styles["calc-label"]}>Approx. Price (₹)</p>
                <h5 className={styles["calc-result"]}>{GoldRateResult || "..."}</h5>
              </div>
            </div>
            <div className={styles["calc-error"]}>{error && <div>{error}</div>}</div>
          </div>

          <div className={styles["page-table"]}>
            <h3
              className={styles["page-content"]}
            >{`22 & 24 Carat Gold Rate in ${cityName} for Last 10 Days (1 gram)`}</h3>
            <table cellPadding="10" className={styles["gold-table"]}>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>22K</th>
                  <th>24K</th>
                </tr>
              </thead>
              <tbody>
                {goldRates.map((rate, index) => (
                  <tr key={index}>
                    <td>{rate.date}</td>
                    <td>
                      {rate.rate22k ? (
                        <span>
                          ₹{rate.rate22k.price}
                          <span
                            style={{
                              color: rate.rate22k.change === 1 ? "green" : rate.rate22k.change === 0 ? "red" : "gray",
                              marginLeft: "4px"
                            }}
                          >
                            {rate.rate22k.change === 1
                              ? rate.rate22k.changeText
                              : rate.rate22k.change === 0
                                ? rate.rate22k.changeText
                                : "(0)"}
                          </span>
                        </span>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      {rate.rate24k ? (
                        <span>
                          ₹{rate.rate24k.price}
                          <span
                            style={{
                              color: rate.rate24k.change === 1 ? "green" : rate.rate24k.change === 0 ? "red" : "gray",
                              marginLeft: "4px"
                            }}
                          >
                            {rate.rate24k.change === 1
                              ? rate.rate24k.changeText
                              : rate.rate24k.change === 0
                                ? rate.rate24k.changeText
                                : "(0)"}
                          </span>
                        </span>
                      ) : (
                        "N/A"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className={styles["faq-container"]}>
            <h2 className={styles["page-title"]}>Gold Rate Frequently Asked Questions</h2>
            <div className={styles["story-container-faq"]}>
              <Collapsible
                trigger={`1. தமிழ்நாட்டில் தங்கம் விலை (Gold Rate in Tamil Nadu) ஒவ்வொரு மாவட்டத்திற்கும் மாறுபடுமா ?`}
              >
                <p>{`பெரும்பாலும் தமிழ்நாட்டில் ஒவ்வொரு மாவட்டத்திற்கும் தங்கம் விலை மாறாது.`}</p>
              </Collapsible>
              <Collapsible
                trigger={`2.  தமிழ்நாட்டில் தங்கம் விலை (Gold Price) எதை வைத்து நிர்ணயிக்கப்படுகிறது ?
`}
              >
                <p
                >{`உலக அளவில் நடக்கும் அரசியல் மாற்றங்கள், பொருளாதார மாற்றங்கள், இந்தியாவில் நடக்கும் மாற்றங்களை பொறுத்து தங்கம் விலை தமிழ்நாட்டில் நிர்ணயிக்கப்படுகிறது.`}</p>
              </Collapsible>
              <Collapsible
                trigger={`3.தமிழ்நாட்டில் தங்கம் (Gold) 22 Carat, 24 Carat, 18 Carat என எப்படி கூறப்படுகிறது ?
`}
              >
                <p
                >{`தமிழ்நாட்டில் தங்கத்தின் அளவோடு பிற உலோகங்கள் எவ்வளவு கலந்திருக்கிறது என்பதை பொறுத்து 18kt, 22ct, 24 karat (gold) தங்கம் என கூறப்படுகிறது.`}</p>
              </Collapsible>

              <Collapsible trigger="4. இன்றைய தங்கம் விலையை (Today Gold rate) பொறுத்து தங்கத்தில் முதலீடு செய்யலாமா?">
                <p>
                  தங்கம் விலை என்பது ஒவ்வொரு நாள் ஒவ்வொரு மாதிரி மாறும். ஆனால், தங்கம் விலை ஏற்றத்தில் இருக்கும்போது
                  தங்கத்தில் முதலீடு செய்ய வேண்டாம் என்பது நிபுணர்களின் கருத்து.
                </p>
              </Collapsible>
              <Collapsible trigger="5. அப்போது இன்றைய தங்கம் விலையை (Gold Rate) வைத்து வாங்கலாமா?">
                <div>
                  <p>
                    தங்கம் வாங்க வேண்டியது கட்டாயம் என்றப்போதும், திருமணம், பண்டிகை என்றப்போதும் மட்டும் தங்கம் விலையை
                    கருத்தில் கொள்ளாமல் வாங்கலாம்.
                  </p>
                </div>
              </Collapsible>
              <Collapsible trigger="6. தமிழ்நாட்டில் இன்றைய 916 தங்கம் விலை (916 Gold Rate) என்ன?">
                <p>
                  தமிழ்நாட்டில் இன்றைய 916 தங்கம் விலை என்றால் தமிழ்நாட்டில் இன்றைய 22 காரட் (22 Carat Gold Rate in
                  Tamil Nadu) தங்கத்தின் விலை ஆகும்.
                </p>
              </Collapsible>
              <Collapsible trigger="7. தமிழ்நாட்டில் 24 காரட் தங்கம் விலையும் (24 carat gold rate in Tamil Nadu), 22 காரட் தங்கம் விலையும் (22 Karat Gold price in Tamil Nadu), 18 காரட் தங்கம் விலையும் (18 Karat Gold Price in Tamil Nadu) வேறு வேறா?">
                <p>
                  ஆம். தமிழ்நாட்டில் 24 காராட் தங்கம் விலையும் (24 Karat gold price), 22 காரட் தங்கம் விலையும், 18 காரட்
                  தங்கம் விலையும் (18K Gold Rate) வேறு வேறு தான்.
                </p>
              </Collapsible>
              <Collapsible trigger="8. இன்றைய தங்கம் விலையும் (Current Gold Rate in Tamil Nadu), நாளைய தங்கம் விலையும் ஒன்றாகத் தான் இருக்கும்?">
                <p>பெரும்பாலும் இன்றைய தங்கம் விலையும் (Gold Price) நாளைய தங்கம் விலையும் மாறித்தான் வரும்.</p>
              </Collapsible>
              <Collapsible trigger="9. ஒரு கிராம் தங்கம் விலையும் (1 Gram Gold Rate), ஒரு பவுன் தங்கம் விலையும் ஒன்றா?">
                <p>இல்லை. ஒரு கிராம் தங்கம் விலையும் (1 Gram Gold Price), ஒரு பவுன் தங்கம் விலையும் வேறு வேறு.</p>
              </Collapsible>
              <Collapsible trigger="10. தமிழ்நாட்டில் ஒரு கிராம் தங்கம் விலையும் (1 Gram Gold Rate /Today's Gold Rate), ஒரு பவுன் தங்கம் விலையும் மாறுபடுமா?">
                <p>
                  ஆம். தமிழ்நாட்டில் ஒரு கிராம் தங்க விலையும் (Live Tamil Nadu Gold Price), ஒரு பவுன் தங்கம் விலையும்
                  மாறும்.
                </p>
              </Collapsible>
            </div>
          </div>
          <div className={styles["city-list-container"]}>
            <h2 className={styles["city-list-title"]}>Today&#39;s Gold Price by City</h2>
            <ul className={styles["city-grid"]}>
              {tamilNaduCities.cities.map((city, index) => (
                <li key={index} className={styles["city-item"]}>
                  <a href={`https://www.vikatan.com/${city.slug}`} className={styles["city-link"]}>
                    {city.en}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles["right-side-panel"]}>
          <aside className={`${styles["right-sidebar"]} ${styles.sidebar}`}>
            <Media query="(min-width:768px)">
              <PGAdwithAd
                adId={`Vikatan2023_Desktop_AP_RightATF_336x280`}
                adSize={[[336, 280], [300, 250]]}
                minHeight={280}
                adDivId={`div-ad-desk-3849069-1690281136-2_${"52d3fe06-4ff8-4e9e-84e1-59c040c0490a"}`}
                class="ad_300_250"
                story={"goldpage"}
                // config={this.props.config}
              />
            </Media>
            <LatestNewsStories />

            {/* <Media query="(min-width:768px)">
                <div className="hidden-mobile">
                  {storyTemplate === "video"
                    ? this.state.latestVideos && (
                        <LatestStoryWidget
                          className={`${styles["related-stories"]} js-related-stories`}
                          collection={this.state.latestVideos}
                          type="videos"
                        />
                      )
                    : this.props.latestStories && (
                        <LatestStoryWidget
                          className={`${styles["related-stories"]} js-related-stories`}
                          collection={this.props.latestStories}
                          type="normal"
                        />
                      )}
                </div>
              </Media> */}

            <Media query="(min-width:768px)">
              <PGAdwithAd
                adId={`Vikatan2023_Desktop_AP_RightMID_336x280`}
                adSize={[[336, 280], [300, 250]]}
                minHeight={280}
                adDivId={`div-ad-desk-3849069-1690281136-1_${123}`}
                class="ad_300_250"
                story={"goldpage"}
                // config={this.props.config}
              />
            </Media>
            <Media query="(min-width:768px)">
              <SpecialBundleCard className="feed-page" config={""} />
            </Media>
            <Media query="(min-width:768px)">
              <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
                <PGAdwithAd
                  adId={`Vikatan2023_Desktop_AP_RHS_300x600`}
                  adSize={[[300, 600]]}
                  minHeight={600}
                  adDivId={`div-ad-desk-3849069-1690281136-0_${1234}`}
                  class="ad-300x600"
                  story={"story"}
                  config={""}
                />
              </div>
            </Media>
          </aside>
        </div>
      </div>
    </React.Fragment>
  );
};

export { GoldDefaultPage };
